import { styled } from 'goober';

const Option = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  &:hover {
    background: var(--hover-bg);
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

const Checkbox = styled('input')`
  cursor: pointer;
  width: 14px;
  height: 14px;
  accent-color: var(--accent);
`;

const Label = styled('label')`
  cursor: pointer;
  color: var(--text);
  font-size: 12px;
  font-weight: 500;
  user-select: none;
  flex: 1;
`;

interface BoundaryOptionProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export function BoundaryOption({ id, label, checked, onChange }: BoundaryOptionProps) {
  const handleChange = (event: Event) => {
    const input = event.target as HTMLInputElement;
    onChange(input.checked);
  };

  return (
    <Option data-testid="boundary-option">
      <Checkbox type="checkbox" id={id} checked={checked} onChange={handleChange} />
      <Label for={id}>{label}</Label>
    </Option>
  );
}
